import { useEffect, useState } from "react";
import { vocabularize } from "src/Common/vocab";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { formatDate, getImageUrl } from "src/Common/common";
import DatePickerModal from "src/Common/datepickermodal";
import POStatusDropDown from "src/Pages/PO/Components/postatusdropdown";
import CustomerDropDown from "src/Pages/WO/Components/dropdown/customerdropdown";
import CustomerService from "src/Services/API/customer.service";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import ApplyButton from "./components/ApplyButton";
import ClearButton from "./components/Clearbutton";
import TechDropDown from "./components/TechDropdown";
import WODropdown from "./components/WODropdown";
import { handleError } from "src/Common/function";
import PaymentDropdown from "src/Pages/WO/Components/createpomodal/PaymentDropdown";
import VendorService from "src/Services/API/vendor.service";
import VendorDropDown from "./components/VendorDropdown";

const POFitlerView = ({ apply, clear }) => {
  const [woNumber, setWoNumber] = useState("");
  const [customer, setCustomer] = useState(-1);
  const [customerName, setCustomerName] = useState("");
  const [tech, setTech] = useState(null);
  const [status, setStatus] = useState(-1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [vendor, setVendor] = useState(null);

  //for fitlerview
  const [woNumbers, setWoNumbers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customerNames, setCustomerNames] = useState([]);
  const [customerKeyword, setCustomerKeyword] = useState("");
  const [techArray, setTechArray] = useState([]);
  const [vendorArray, setVendorArray] = useState([]);

  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [isStartDate, setIsStartDate] = useState(true);
  const [paymentType, setPaymentType] = useState(-1);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const branch = searchParams.get("branch");

  useEffect(() => {
    if (criteria) {
      let saveCriteria = JSON.parse(criteria);

      setStatus(saveCriteria.status);
      setCustomer(saveCriteria.customer);
      setCustomerName(
        customers.find((item) => item.id === saveCriteria.customer)
          ? customers.find((item) => item.id === saveCriteria.customer).companyName
          : ""
      );
      setTech(
        techArray.find((item) => item.id === saveCriteria.tech)
          ? techArray.find((item) => item.id === saveCriteria.tech)
          : null
      );
      setStartDate(saveCriteria.startDate);
      setEndDate(saveCriteria.endDate);
      setPaymentType(saveCriteria.paymentType);
      setVendor(saveCriteria.vendor);
    }
  }, [customers, techArray]);

  useEffect(() => {
    // get_all is customer:read-gated; the filter only needs id/companyName,
    // so use the ungated picker endpoint.
    CustomerService.getForAssign(customerKeyword)
      .then((response) => {
        if (response.status == 200) {
          setCustomers(response.data);
          setCustomerNames(response.data.map((item) => item.companyName));
        }
      })
      .catch((error) => {
        console.log("customer fetching error: ", error);
      });

    VendorService.getAllForSelection()
      .then((response) => {
        if (response.status == 200) {
          setVendorArray(response.data);
        }
      })
      .catch((error) => {
        console.log("vendor fetching error: ", error);
      });

    // Roles are dynamic (managed in IAM), so the picker lists all enabled
    // users instead of hardcoding role names.
    UserService.getUsersForAssign(null, branch)
      .then((response) => {
        if (response.status == 200) {
          setTechArray(
            response.data.filter((user) => user.isEnabled === true).sort((a, b) => a.name.localeCompare(b.name))
          );
        }
      })
      .catch((error) => handleError(error));

    WOService.getAllOrderNumber(branch)
      .then((response) => {
        setWoNumbers(response.data.orderNumbers);
      })
      .catch((error) => {
        console.log("wo number fetching error: ", error);
      });
  }, [branch, customerKeyword]);

  const customerSelected = (index) => {
    setCustomer(customers[index].id);
    setCustomerName(customers[index].companyName);
  };

  const vendorSelected = (value) => {
    setVendor(value.name);
  };

  const applyFilter = () => {
    apply({
      wo: woNumber,
      customer,
      tech: tech ? tech.id : -1,
      status,
      startDate,
      endDate,
      paymentType,
      vendor,
    });
  };

  const clearFilter = () => {
    setWoNumber(null);
    setCustomer(-1);
    setCustomerName("");
    setTech(-1);
    setStatus(-1);
    setStartDate(null);
    setEndDate(null);
    setPaymentType(-1);
    setVendor(-1);
    apply({
      wo: null,
      customer: -1,
      tech: null,
      status: -1,
      startDate: null,
      endDate: null,
      paymentType: -1,
      vendor: null,
    });

    clear();

    let url = removeQueryParam("criteria");
    navigate(url);
  };

  const techSelected = (index) => {
    setTech(techArray[index]);
  };

  const woSelected = (number) => {
    setWoNumber(number);
  };

  const removeQueryParam = (queryToRemove) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    if (queryToRemove) {
      url.delete(queryToRemove);
    }

    return `${currentPath}?${url.toString()}`;
  };

  return (
    <div className="w-full flex flex-wrap gap-3 py-10 relative z-20 pr-[120px]" data-tour="po-filter-panel">
      <div className="absolute top-5 right-5 flex flex-col gap-3">
        <ApplyButton onClicked={applyFilter} dataTour="po-filter-apply" />
        <ClearButton onClicked={clearFilter} dataTour="po-filter-clear" />
      </div>
      <div className="w-[120px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">{vocabularize("by WO")}: </p>
        <WODropdown options={woNumbers} selectedWO={woNumber} onSelect={woSelected} />
      </div>
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Customer: </p>
        <CustomerDropDown
          options={customerNames}
          defaultOption={customer >= 0 ? customerName : "Select"}
          onSelect={customerSelected}
          keywordChanged={setCustomerKeyword}
        />
      </div>
      {/* <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Status: </p>
        <WOStatusDropDown defaultOption={status} onSelect={(value) => setStatus(value)} />
      </div> */}
      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Technician: </p>
        <TechDropDown options={techArray} selectedTech={tech} onSelect={techSelected} />
      </div>

      <div className="w-[200px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">by Status: </p>
        <POStatusDropDown defaultOption={status} onSelect={(value) => setStatus(value)} />
      </div>

      <div className="w-[130px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Start date: </p>
        <div
          onClick={() => {
            setDatePickerOpen(true);
            setIsStartDate(true);
          }}
          className="w-full h-[30px] border-borderColor border-[1px] rounded-[6px] flex items-center px-1 gap-1"
        >
          <img src={getImageUrl("/images/wo/date.png")} />
          {startDate ? (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">
              {formatDate(startDate, "MM/DD/YYYY")}
            </p>
          ) : (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-inputFieldTextColor">Start Date</p>
          )}
        </div>
      </div>

      <div className="w-[130px] flex flex-col gap-2 ">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">End date: </p>
        <div
          onClick={() => {
            setDatePickerOpen(true);
            setIsStartDate(false);
          }}
          className="w-full h-[30px] border-borderColor border-[1px] rounded-[6px] flex items-center px-1 gap-1"
        >
          <img src={getImageUrl("/images/wo/date.png")} />
          {endDate ? (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-titleColor">
              {formatDate(endDate, "MM/DD/YYYY")}
            </p>
          ) : (
            <p className="text-[12px] font-OpenSansMedium font-[400] text-inputFieldTextColor">End Date</p>
          )}
        </div>
      </div>

      <div className="w-[130px] flex flex-col gap-2">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Payment Type:</p>
        <PaymentDropdown itemClicked={setPaymentType} defaultValue={paymentType} />
      </div>

      <div className="w-[200px] flex flex-col gap-2">
        <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Vendor:</p>
        <VendorDropDown options={vendorArray} defaultOption={vendor} onSelect={vendorSelected} />
      </div>

      {datePickerOpen && (
        <DatePickerModal
          shown={datePickerOpen}
          pSelectedDate={isStartDate ? startDate : endDate}
          cancelClicked={() => setDatePickerOpen(false)}
          dateSelected={(date) => {
            if (isStartDate) {
              setStartDate(date);
            } else {
              setEndDate(date);
            }
            setDatePickerOpen(false);
          }}
          timeVisible={false}
        />
      )}
    </div>
  );
};

export default POFitlerView;
